import { blue, gray, red } from '../../../../../../ReactSharedScripts/components/Color';
import { DocumentFileExtension } from 'modules/document/components/DocumentCard/types';
import { isUndefined } from '../../../../../../ReactSharedScripts/predicates/type';
import { FileAttachedO } from '../../../../../../ReactSharedScripts/components/Icons/FileAttachedO';
import { FilePdfO } from '../../../../../../ReactSharedScripts/components/Icons/FilePdfO';
import { FileWordO } from '../../../../../../ReactSharedScripts/components/Icons/FileWordO';
import { FilePictureO } from '../../../../../../ReactSharedScripts/components/Icons/FilePictureO';

export const getExtensionIconData = (extension?: DocumentFileExtension) => {
	if (isUndefined(extension)) {
		return {
			Icon: FileAttachedO,
			fill: gray[6],
		};
	}

	switch (String(extension).toLowerCase()) {
		case 'pdf':
			return {
				Icon: FilePdfO,
				fill: red[6],
			};
		case 'doc':
		case 'docx':
			return {
				Icon: FileWordO,
				fill: blue[6],
			};
		case 'png':
		case 'jpg':
		case 'jpeg':
			return {
				Icon: FilePictureO,
				fill: gray[6],
			};
		default:
			return {
				Icon: FileAttachedO,
				fill: gray[6],
			};
	}
};
